/**
 * The value an `<input type="date">` expects, read off the local calendar.
 * `toISOString()` would shift the day for anyone east of UTC.
 */
export const asDayValue = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

// Built once rather than per rendered cell: constructing an Intl formatter is ~25x
// the cost of reusing one, and the visits list re-renders every row per keystroke.
const shortFormat = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const longFormat = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/** The canonical rendering of a visit date — used wherever the two views must agree. */
export const formatVisitAt = (dateStr: string): string => shortFormat.format(new Date(dateStr));

/** Long form, for the visit detail heading. */
export const formatVisitAtLong = (dateStr: string): string => longFormat.format(new Date(dateStr));
